/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const featureFlagCheckDataFeatureSchema = z.enum([
	'global-ai-chat',
	'enlarged-feed-images',
	'talent-pool-ai-summary',
	'asset-hub-signed-uploads',
	'whatsapp-ai-agent',
	'whatsapp-direct-send',
	'whatsapp-ai-continuation',
	'microsoft-365-calendar',
])

export type FeatureFlagCheckDataFeatureSchema = z.infer<typeof featureFlagCheckDataFeatureSchema>
